import { imprintsConstants } from '../constants/imprints';

export function imprints(state = {imprint: {}, card: {}, autoCompleteLoading: false, forceLoadAllData: false, top: {}, timeseries: {} }, action) {
    switch (action.type) {
        case imprintsConstants.GET_IMPRINTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case imprintsConstants.GET_IMPRINTS_SUCCESS:
            return {

                ...state,
                loading: false,
                items: action.imprints,
                metadata: action.metadata,
                total: action.total
            };
        case imprintsConstants.GET_IMPRINTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case imprintsConstants.GET_IMPRINTS_AUTOCOMPLETE_REQUEST:
            return {
                ...state,
                autocomplete_items: [],
                autoCompleteLoading: true
            };
        case imprintsConstants.GET_IMPRINTS_AUTOCOMPLETE_SUCCESS:
            return {

                ...state,
                autoCompleteLoading: false,
                autocomplete_items: action.imprints
            };
        case imprintsConstants.GET_IMPRINTS_AUTOCOMPLETE_FAILURE:
            return {
                ...state,
                autoCompleteLoading: false,
                error: action.error
            };

        case imprintsConstants.GET_TOP_IMPRINTS_REQUEST:

            return {
                ...state,
                top: {
                    ...state.top,
                    [action.id]: {
                        loading: true,
                        data: undefined,
                        topTotal: undefined,
                        metadata: null
                    }
                }
            };
        case imprintsConstants.GET_TOP_IMPRINTS_SUCCESS:
            return {

                ...state,
                top: {
                    ...state.top,
                    [action.id]: {
                        loading: false,
                        data: action.imprints,
                        topTotal: action.total,
                        metadata: action.metadata,
                    }
                },
                timeseries: {
                    ...state.timeseries,
                    [action.id]: undefined
                },
                forceLoadAllData: false
            };
        case imprintsConstants.GET_TOP_IMPRINTS_FAILURE:
            return {
                ...state,
                topLoading: false,
                error: action.error,
                forceLoadAllData: false
            };

        case imprintsConstants.GET_IMPRINT_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case imprintsConstants.GET_IMPRINT_DETAILS_SUCCESS:
            let imprint = state.imprint;
            imprint[action.id] = action.imprint;
            return {
                ...state,
                loading: false,
                imprint: imprint
            };
        case imprintsConstants.GET_IMPRINT_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case imprintsConstants.GET_IMPRINTS_CARD_REQUEST:
            return {
                ...state,
                cardLoading: true
            };
        case imprintsConstants.GET_IMPRINTS_CARD_SUCCESS:
            let card = state.card;
            card[action.id] = action.card;
            return {
                ...state,
                cardLoading: false,
                card: card
            };
        case imprintsConstants.GET_IMPRINTS_CARD_FAILURE:
            return {
                ...state,
                cardLoading: false,
                error: action.error
            };

        case imprintsConstants.GET_STREAMS_STATS_REQUEST:
            return {
                ...state,
                streamsLoading: true
            };
        case imprintsConstants.GET_STREAMS_STATS_SUCCESS:
            return {
                ...state,
                streamsLoading: false,
                streams: action.imprints
            };
        case imprintsConstants.GET_STREAMS_STATS_FAILURE:
            return {
                ...state,
                streamsLoading: false,
                error: action.error
            };

        case imprintsConstants.GET_TIMESERIES_IMPRINTS_REQUEST:
            return {
                ...state,
                timeseries: {
                    ...state.timeseries,
                    [action.id]: {
                        loading: true,
                        data: undefined,
                    }
                }
            };

        case imprintsConstants.GET_TIMESERIES_IMPRINTS_SUCCESS:
            return {
                ...state,
                timeseries: {
                    ...state.timeseries,
                    [action.id]: {
                        loading: false,
                        data: action.imprints,
                    }
                }
            };

        case imprintsConstants.GET_TIMESERIES_IMPRINTS_FAILURE:
            return {
                ...state,
                timeseries: {
                    ...state.timeseries,
                    [action.id]: {
                        loading: false,
                        data: undefined,
                    }
                },
                error: action.error
            };

        case imprintsConstants.FORCE_LOAD_ALL_DATA: {
            return {
                ...state,
                forceLoadAllData: action.force,
                topLoading: true
            }
        }
        case imprintsConstants.GET_ALL_IMPRINTS_REQUEST:
            return {
                ...state,
                allLoading: true
            };
        case imprintsConstants.GET_ALL_IMPRINTS_SUCCESS:
            return {
        
                ...state,
                allLoading: false,
            };
        case imprintsConstants.GET_ALL_IMPRINTS_FAILURE:
            return {
                ...state,
                allLoading: false,
                error: action.error
            };
            
        default:
            return state
    }
}